
import { Flicking } from '@egjs/vue-flicking';
import ReviewShortsMedium from './components/ReviewShortsMedium';
import CoachMark from './components/CoachMark';
import { SWIPE_THRESHOLD } from '@/constants/SHORTS_POPUP';
import ReviewDetailPanelPc from './components/ReviewDetailPanelPc';

const FLICKING_OPTIONS = {
  bound: false,
  horizontal: false,
  panelsPerView: 1.15,
  moveType: 'strict',
  threshold: SWIPE_THRESHOLD,
  inputType: [],
  align: 'center'
};

const WHEEL_DELTA_THRESHOLD = 50;

export default {
  i18nComponentKey: 'ReviewsShortsPopup.ReviewsShortsPopupPc',
  name: 'ReviewsShortsPopupPc',
  components: {
    Flicking,
    ReviewShortsMedium,
    CoachMark,
    ReviewDetailPanelPc
  },
  props: {
    reviewMedia: {
      type: Array,
      required: true
    },
    popupParams: {
      type: Object,
      default: () => ({})
    },
    isVideoMuted: {
      type: Boolean,
      default: true
    },
    initialMediaIndex: {
      type: Number,
      default: 0
    },
    showCoachMark: {
      type: Boolean,
      default: true
    },
    pagy: {
      type: Object,
      default: null
    },
    showCloseButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentIndex: null,
      panelHeight: null
    };
  },
  computed: {
    layoutStyle() {
      if (!this.panelHeight) return {};
      return { '--panel-height': `${this.panelHeight}px` };
    },
    canMovePrev() {
      if (this.currentIndex === null) return false;
      if (this.currentIndex > 0) return true;
      return !!(this.pagy && this.pagy.prev);
    },
    canMoveNext() {
      if (this.currentIndex === null) return false;
      if (this.currentIndex < this.reviewMedia.length - 1) return true;
      return !!(this.pagy && this.pagy.next);
    },
    currentReview() {
      if (this.currentIndex === null || !this.reviewMedia[this.currentIndex]) {
        return null;
      }
      return this.reviewMedia[this.currentIndex].review;
    },
    flickingOptions() {
      return {
        ...FLICKING_OPTIONS,
        defaultIndex: this.initialMediaIndex
      };
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyDown);
    this.$el.addEventListener('wheel', this.onWheel, { passive: false });
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
    this.$el.removeEventListener('wheel', this.onWheel);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    movePrev() {
      if (this.showCoachMark) {
        this.$emit('dismiss-coach-mark');
        return;
      }

      if (
        !this.$refs.flicking ||
        this.$refs.flicking.animating ||
        !this.canMovePrev
      )
        return;

      if (this.currentIndex > 0) {
        this.$refs.flicking.prev().catch(() => {});
      } else {
        this.$emit('prepend-page', {
          page: this.pagy.prev,
          callback: addedCount => {
            this.$nextTick(() => {
              this.$refs.flicking.moveTo(addedCount, 0);
              this.currentIndex = addedCount;
            });
          }
        });
      }
    },
    moveNext() {
      if (this.showCoachMark) {
        this.$emit('dismiss-coach-mark');
        return;
      }

      if (
        !this.$refs.flicking ||
        this.$refs.flicking.animating ||
        !this.canMoveNext
      )
        return;

      if (this.currentIndex < this.reviewMedia.length - 1) {
        this.$refs.flicking.next().catch(() => {});
      } else {
        this.$emit('append-page', {
          page: this.pagy.next,
          callback: () => {
            this.$nextTick(() => {
              this.$refs.flicking.next().catch(() => {});
            });
          }
        });
      }
    },
    onKeyDown(event) {
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.movePrev();
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.moveNext();
      }
    },
    isInsideDetailPanel(target) {
      const detailPanel = this.$refs.detailPanel;
      return detailPanel && detailPanel.$el.contains(target);
    },
    onWheel(event) {
      if (this.isInsideDetailPanel(event.target)) return;

      event.preventDefault();
      if (Math.abs(event.deltaY) < WHEEL_DELTA_THRESHOLD) return;

      if (event.deltaY < 0) {
        this.movePrev();
      } else if (event.deltaY > 0) {
        this.moveNext();
      }
    },
    onWillChange(e) {
      this.currentIndex = e.index;
    },
    onFlickingReady() {
      const flicking = this.$refs.flicking;
      if (!flicking) return;

      this.currentIndex = flicking.index;

      const panelEl =
        flicking.currentPanel?.$el || flicking.currentPanel?.element;
      if (panelEl) {
        this.panelHeight = panelEl.offsetHeight;
        this.resizeObserver = new ResizeObserver(([entry]) => {
          this.panelHeight = entry.contentRect.height;
        });
        this.resizeObserver.observe(panelEl);
      }
    }
  }
};
